import { Icon } from "@dmm-com/rocket-web-ui-library";
import * as Styled from "./style";

type ListItemProps = {
  name: string;
  isHistory?: boolean;
  isGravure?: boolean;
  onNavigate: () => void;
  onRemoveHistory?: () => void;
};

export const ListItem = (props: ListItemProps) => {
  const { isHistory, name, isGravure = false, onNavigate, onRemoveHistory } = props;

  return (
    <Styled.LIList isHistory={isHistory}>
      <Styled.ButtonItem type="button" onClick={onNavigate} isHistory={isHistory}>
        <Styled.SpanText>{name}</Styled.SpanText>
        {isGravure && <Styled.SpanGravureText>&nbsp;(グラビア)</Styled.SpanGravureText>}
      </Styled.ButtonItem>
      {isHistory && (
        <Styled.RemoveButton
          onClick={() => {
            if (onRemoveHistory) onRemoveHistory();
          }}
        >
          <Icon name="clear" size="L" color="GRAY900" />
        </Styled.RemoveButton>
      )}
    </Styled.LIList>
  );
};
